export const CUSTOMER_TYPE_BADGE_MAP = {
  1: {
    label: 'P3KE',
    backgroundColor: '#D0ECFF',
    textColor: '#0F6EB5',
  },
  2: {
    label: 'BPUM',
    backgroundColor: '#D0ECFF',
    textColor: '#0F6EB5',
  },
  3: {
    label: 'DP3',
    backgroundColor: '#D0ECFF',
    textColor: '#0F6EB5',
  },
  4: {
    label: 'DP3',
    backgroundColor: '#D0ECFF',
    textColor: '#0F6EB5',
  },
  99: {
    label: 'On Demand',
    backgroundColor: '#DEF8DD',
    textColor: '#34A853',
  },
};

export const DEFAULT_CUSTOMER_TYPE_BADGE = {
  label: '-',
  backgroundColor: '#D0ECFF',
  textColor: '#0F6EB5',
};

export const getCustomerTypeBadge = (sourceTypeId) => {
  return CUSTOMER_TYPE_BADGE_MAP[String(sourceTypeId)] || DEFAULT_CUSTOMER_TYPE_BADGE;
};
